// Whether this deployment lets anyone create an account, and where to send the
// people it turns away.
//
// Registration is CLOSED unless a build explicitly opts in, so a deployment
// that forgets the variable fails safe rather than leaving the front door open.
// The YES spelling matches REACT_APP_AUTHENTICATE_USERS, the other auth switch.
export const SIGNUP_ENABLED = process.env.REACT_APP_SIGNUP_ENABLED === 'YES';

// New hosted accounts go to polite.ai instead.
export const PARTNER = {
  name: 'polite.ai',
  homeUrl: 'https://polite.ai',
  url: 'https://polite.ai/waitlist',
  pricingUrl: 'https://polite.ai/pricing',
  apiDocsUrl: 'https://aplisay.com/docs/api',
};

// Tagged on the error thrown when an OAuth popup turns out to be a new account,
// so api/user.js can route that person to the referral page rather than firing
// an error toast at them. Firebase error codes are dotted strings; this is
// deliberately not one, so it can never collide with theirs.
export const SIGNUP_CLOSED = 'aplisay/signup-closed';

export const SIGNUP_CLOSED_MESSAGE =
  `Aplisay Playground is not taking new accounts. You can request access to ${PARTNER.name} at ${PARTNER.url}.`;
